import { createRoot } from 'react-dom/client';

import { B2c } from './B2c';

document.querySelector('#b2c') && createRoot(document.querySelector('#b2c') as Element).render(<B2c />);
